export default "__VITE_ASSET__BhtAFPJK__"